import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token }).then(() => setStatus("ok")).catch(() => setStatus("error"));
  }, [token]);

  return (
    <AuthShell title="Email verification" subtitle="Confirming your email address">
      <div className="text-center py-6" data-testid="verify-status">
        {status === "loading" && <Loader2 className="h-12 w-12 text-blue-600 mx-auto animate-spin" />}
        {status === "ok" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" />
            <p className="mt-4 text-slate-600">Your email has been verified. You're all set!</p>
            <Link to="/app/dashboard"><Button className="mt-6 w-full bg-blue-600 hover:bg-blue-700">Go to dashboard</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-red-500 mx-auto" />
            <p className="mt-4 text-slate-600">This verification link is invalid or has expired.</p>
            <Link to="/login"><Button variant="outline" className="mt-6 w-full">Back to login</Button></Link>
          </>
        )}
      </div>
    </AuthShell>
  );
}
